import { createSlice } from "@reduxjs/toolkit";
import { BoostingCampaign } from "@vviinn/user-managment-client-ts";
import { FetchableState } from "..";
import { changeActiveSite } from "../site/site-slice";
import { deleteBoosting, fetchBoosting, upsertBoosting } from "./boostingRequests";

type BoostingState = FetchableState & {
  boosting: BoostingCampaign[];
};

const initialState: BoostingState = {
  boosting: [],
  loading: false,
  error: false,
  status: "idle",
};

const boostingSlice = createSlice({
  name: "boosting",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBoosting.pending, (state) => {
      state.error = false;
      state.loading = true;
      state.status = "loading";
    });

    builder.addCase(fetchBoosting.rejected, (state) => {
      state.error = true;
      state.loading = false;
      state.status = "error";
      state.boosting = [];
    });

    builder.addCase(fetchBoosting.fulfilled, (state, { payload }) => {
      state.error = false;
      state.loading = false;
      state.boosting = payload;
      state.status = "fulfilled";
    });

    builder.addCase(upsertBoosting.fulfilled, (state, { payload }) => {
      const index = state.boosting.findIndex((b) => b.id === payload.id);
      if (index !== -1) {
        state.boosting[index] = payload;
      } else {
        state.boosting.push(payload);
      }
    });

    builder.addCase(deleteBoosting.fulfilled, (state, { meta }) => {
      state.boosting = state.boosting.filter(
        (boostingCampaign) => boostingCampaign.id !== meta.arg.value.campaignId,
      );
    });
    builder.addCase(changeActiveSite, (state) => {
      if (!state.boosting.length) return;
      state.boosting = [];
      state.status = "idle";
    });
  },
});

export default boostingSlice.reducer;
